import axios from 'axios';
import toast from 'react-hot-toast';

import { logout } from '../features/auth/authSlice';

const BASE_URL = process.env.REACT_APP_CLIENT_URL;

const API = axios.create({
  baseURL: BASE_URL
  //withCredentials: true
});

let store;
export const injectStore = (temp_store) => {
  store = temp_store;
};

const getSuportIdFromResponse = (responseData) => {
  if (responseData && responseData.includes('support ID')) {
    // CHECK IF WAF RESPONSE IS IN HTML FORMAT
    let splitedMessage = [];
    if (responseData.includes('<br>')) {
      splitedMessage = responseData.split('<br>');
      splitedMessage = splitedMessage[2]?.split(':');
    } else {
      splitedMessage = responseData.split(':');
    }
    return splitedMessage[1];
  }
  return null;
};

// Add a response interceptor
API.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const contentType = response?.headers?.['content-type'] ?? '';
    if (typeof contentType === 'string' && contentType.startsWith('text/html')) {
      const supportID = getSuportIdFromResponse(response.data);
      if (supportID) {
        toast.error(
          `L'URL demandé a été rejeté. Veuillez consulter votre administrateur. ID support WAF: ${supportID}`
        );
      }
    }
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const status = error.response?.status;
    if (status === 500 || status === 404) {
      console.log('');
    } else if (status === 400) {
      console.log('');
    } else if (status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

// export const setClientToken = (token: string | null) => {
//   API.defaults.headers.common.Authorization = token;
// };

export const apiPost = (url: string, data: any, config?: any) => API.post(url, data, config);

export const apiGet = (url: string, config?: any) => API.get(url, config);
